import { apolloClient } from 'src/modules/graphql-client';
import { getValidationErrorMessages } from 'src/modules/graphql-client/errors';
import { getOperationNameFromQuery } from 'src/modules/utils';
import type { Zone } from 'src/types';

import { logError } from '../../modules/error-logger/browserLog';

import { PROCESS_UPLOADED_RESUME } from './process-uploaded-resume.graphql';

export const RESUME_LIMIT_EXCEEDED = 'resume-limit-error';

export const attachResumeToProfile = ({
  resumeId,
  contextId,
  zone,
}: {
  resumeId: string;
  contextId: string;
  zone: Zone;
}) =>
  apolloClient
    .mutate({
      mutation: PROCESS_UPLOADED_RESUME,
      variables: {
        input: {
          id: resumeId,
          parsingContext: {
            id: contextId,
          },
          zone,
        },
      },
      errorPolicy: 'all',
    })
    .catch((err: unknown) => {
      logError(
        {
          ...(err as Error),
          type: 'attach-resume-unexpected',
        },
        {
          error: err,
          operationName: getOperationNameFromQuery(PROCESS_UPLOADED_RESUME),
        },
      );
      return null;
    })
    .then((res) => {
      const resume = res?.data?.processUploadedResume?.resume;
      const uri = resume?.fileMetadata?.uri;

      const validation = getValidationErrorMessages(res);
      const validationError = validation[0] || '';
      const hasHitResumeLimit = validationError.includes(
        'Resume limit reached',
      );

      if (hasHitResumeLimit) {
        throw new Error(RESUME_LIMIT_EXCEEDED);
      }

      if (validationError) {
        throw new Error(validationError);
      }

      if (!uri) {
        throw new Error('Error uploading resumé');
      }

      return { uri, resume };
    });
